// Public launch screen shared by every startup gate. No household data is rendered here.
export default function StartupSurface({ testId = "startup-surface" }) {
  return (
    <div data-testid={testId} role="status" aria-live="polite" aria-busy="true"
      style={{position:"fixed",inset:0,zIndex:50,display:"grid",placeItems:"center",background:"#FAFAF8",color:"#153A55",fontFamily:"Inter,Arial,sans-serif"}}>
      <div style={{textAlign:"center",padding:24}}>
        <img src="/icons/icon-192-v2.png" alt="" width="72" height="72"
          style={{display:"block",margin:"0 auto 20px",borderRadius:20}} />
        <h1 style={{fontSize:24,fontWeight:700,lineHeight:1.3,margin:0,letterSpacing:"-0.4px"}}>FrontRow Parents</h1>
        <p style={{fontSize:14,lineHeight:1.5,margin:"10px 0 0",color:"#667085"}}>Opening FrontRow…</p>
      </div>
    </div>
  );
}
